import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { FlowNode, FlowEdge } from './workflowStore';

export interface SavedWorkflow {
  id: string;
  name: string;
  description: string;
  status: 'draft' | 'active' | 'inactive';
  nodes: FlowNode[];
  edges: FlowEdge[];
  uploadedFile: {
    id: string;
    name: string;
    rowCount: number;
    columns: string[];
  } | null;
  nodeCount: number;
  executionCount: number;
  lastExecutedAt?: string;
  createdAt: string;
  updatedAt: string;
}

interface WorkflowListState {
  workflows: SavedWorkflow[];
  addWorkflow: (wf: SavedWorkflow) => void;
  updateWorkflow: (id: string, updates: Partial<SavedWorkflow>) => void;
  deleteWorkflow: (id: string) => void;
  getWorkflow: (id: string) => SavedWorkflow | undefined;
  incrementExecutionCount: (id: string) => void;
}

export const useWorkflowListStore = create<WorkflowListState>()(
  persist(
    (set, get) => ({
      workflows: [],

      addWorkflow: (wf) =>
        set((state) => ({ workflows: [wf, ...state.workflows] })),

      updateWorkflow: (id, updates) =>
        set((state) => ({
          workflows: state.workflows.map((wf) =>
            wf.id === id
              ? { ...wf, ...updates, updatedAt: new Date().toISOString() }
              : wf
          ),
        })),

      deleteWorkflow: (id) =>
        set((state) => ({
          workflows: state.workflows.filter((wf) => wf.id !== id),
        })),

      getWorkflow: (id) => get().workflows.find((wf) => wf.id === id),

      incrementExecutionCount: (id) =>
        set((state) => ({
          workflows: state.workflows.map((wf) =>
            wf.id === id
              ? {
                  ...wf,
                  executionCount: wf.executionCount + 1,
                  lastExecutedAt: new Date().toISOString(),
                }
              : wf
          ),
        })),
    }),
    {
      name: 'workflow-list-storage',
    }
  )
);
